/* eslint-disable import/prefer-default-export */
import { useStoreActions, useReducerData } from 'store/hooks';
// ACTIONS
import * as productDetailActions from 'views/ProductDetail/actions';
import * as addProductActions from './actions';

export const useIndexData = () => {
  const supplierList = useReducerData('addProduct', 'supplierList.data', []);
  const productCategories = useReducerData('addProduct', 'productCategories.data', []);
  const factoryList = useReducerData('addProduct', 'factoryList.data', []);
  const buyerList = useReducerData('addProduct', 'buyerList.data', []);
  const loginState = useReducerData('loginState', 'profile', {});
  const productDetail = useReducerData('productDetail', 'productDetail.data', {});

  return {
    supplierList,
    productCategories,
    factoryList,
    buyerList,
    loginState,
    productDetail,
  };
};

export const useActions = () => {
  return useStoreActions({
    ...addProductActions,
    ...productDetailActions,
  });
};
